module.exports = __webpack_public_path__ + "static/media/within.c18c01f6.mov";


//////////////////
// WEBPACK FOOTER
// ./src/projects/rostery/src/within.mov
// module id = 641
// module chunks = 0